import React from "react";
import Divider from "./Divider";
import { cars } from "../data/cars";
import "../styles/fleet.css";

const PHONE_NUMBER = "+36706276599";
const PHONE_TEL = `tel:${PHONE_NUMBER}`;

const Fleet = () => {
  const handleCallClick = (e, carName) => {
    e.preventDefault();

    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17865564109/hgPsCO6_qeAbEM2_-8ZC",
        value: 1.0,
        currency: "HUF",
        event_label: `fleet_call_${carName}`,
        event_callback: () => {
          window.location.href = PHONE_TEL;
        },
      });
    } else {
      window.location.href = PHONE_TEL;
    }
  };

  return (
    <section id="fleet" className="fleet-section">
      <div className="container">
        <h2 className="fleet-title">Autóflottánk</h2>
        <Divider />

        <p className="fleet-lead">
          Válassz megbízható, karbantartott autóink közül! Minden járművünk
          érvényes országos autópálya-matricával rendelkezik, tisztán és
          felkészítve kerül átadásra.
        </p>

        <div className="row g-4">
          {cars.map((car) => (
            <div key={car.id} className="col-md-4">
              <div className="fleet-card">
                <img src={car.image} alt={car.name} className="fleet-img" />

                <h3 className="fleet-name">{car.name}</h3>

                <ul className="fleet-details">
                  <li>
                    <strong>Évjárat:</strong> {car.year}
                  </li>
                  <li>
                    <strong>Szín:</strong> {car.color}
                  </li>
                  <li>
                    <strong>Kivitel:</strong> {car.body}
                  </li>
                  <li>
                    <strong>Motor:</strong> {car.engine}
                  </li>
                  <li>
                    <strong>Matrica:</strong> {car.motorway}
                  </li>
                  <li>
                    <strong>Vonóhorog:</strong> {car.towbar}
                  </li>
                  <li>
                    <strong>Kategória:</strong> {car.category}
                  </li>
                </ul>

                <div className="fleet-prices">
                  <p>
                    <strong>1 nap:</strong> {car.price_1}
                  </p>
                  <p>
                    <strong>2–3 nap:</strong> {car.price_2_3}
                  </p>
                  <p>
                    <strong>4–10 nap:</strong> {car.price_4_10}
                  </p>
                  <p>
                    <strong>Kaució:</strong> {car.deposit}
                  </p>
                </div>

                <a
                  href={PHONE_TEL}
                  className="fleet-cta"
                  onClick={(e) => handleCallClick(e, car.name)}
                >
                  Foglald le most!
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="fleet-footnote">
          A díjak tartalmazzák a kötelező és casco biztosítást, a
          teljesítményadót és a rendeltetésszerű használatból eredő költségeket.
          Napi 250 km használattal (felette 35 Ft/km). 10 nap felett kérje
          egyedi ajánlatunkat.
        </p>
      </div>
    </section>
  );
};

export default Fleet;
